<template>
  <div>
    <v-img src="./contacto.jpg" contain></v-img>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>